<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong
            class="card-title mb-3"
          >{{(isAdd)? 'Add Stock' : (pname)? pname+ ' Details': 'Details'}}</strong>
        </div>
        <!-- <div class="col-md-2">
          <download v-if="!isAdd" :tableId="'users'" :fileName="'portfolios-details'"></download>
        </div>-->
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body mb-15" v-if="isAdd">
      <AddStock :pid="portId" @submitForm="submitForm"></AddStock>
    </div>
    <div class="card-body mb-15" v-if="!isAdd">
      <div class="row mb5">
        <div class="col-md-10"></div>
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-2">
          <button type="button" @click="addNew()" class="btn btn-sm btn-success pull-right">
            <i class="fa fa-plus"></i> Add Stock
          </button>
        </div>
      </div>
      <div class="table-responsive app mb-15" v-dragscroll="true">
        <table id="users" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="field.name">
                <span v-if="field.name==='status'">{{(row['status']===false)? 'Inactive':'Active'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="(action, index) in actions"
                    v-bind:key="index+'-action-'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages>1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li
              v-for="(page, index) in pages"
              v-bind:key="index+page"
              class="page-item"
              :class="(current_page == page)? 'active':''"
            >
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <h4>Stockwise</h4>
            <table class="table">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="field in stockTableFields"
                    v-bind:key="'field'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in outputData.stockwise" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in stockTableFields" v-bind:key="field.name+index">
                    <span v-if="field.type==='string'">{{row[field.title]}}</span>
                    <span v-else>
                      <span
                        v-if="field.unit==='(%)'"
                      >{{(row[field.title])? getFixed(row[field.title]*100): getFixed(row[field.title])}}</span>
                      <span v-else>{{getFixed(row[field.title])}}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Total</td>
                  <td v-for="field in stockTableFields" v-bind:key="field.name+index">
                    <span
                      v-if="outputData['total_'+field.title]"
                    >{{getFixed(outputData['total_'+field.title])}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <h4>Sectorwise</h4>
            <table class="table">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="field in sectorTableFields"
                    v-bind:key="'field'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in outputData.sectorwise" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in sectorTableFields" v-bind:key="field.title+index">
                    <span v-if="field.type==='string'">{{row[field.title]}}</span>
                    <span v-else>
                      <span
                        v-if="field.unit==='(%)'"
                      >{{(row[field.title])? getFixed(row[field.title]*100): row[field.title]}}</span>
                      <span v-else>{{getCustomLabel(row[field.title])}}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <h4>Market Cap-wise</h4>
            <table class="table">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="field in mcapTableFields"
                    v-bind:key="'field'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in outputData.industrywise" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in mcapTableFields" v-bind:key="field.title+index">
                    <span v-if="field.type==='string'">{{getCustomLabel(row[field.title])}}</span>
                    <span v-else>
                      <span
                        v-if="field.unit==='(%)'"
                      >{{(row[field.title])? getFixed(row[field.title]*100): row[field.title]}}</span>
                      <span v-else>{{getCustomLabel(row[field.title])}}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12">
          <h4 class="text-left">Returns across time periods</h4>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th
                    v-for="(hd, index) in compositeIndex"
                    :key="'portfolio'+index"
                    class="text-center"
                  >{{hd.name}}</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
                <tr v-if="outputData.portfolio_index">
                  <td>Portfolio Index</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'portfoliotd'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.portfolio_index[hd.title] * 100) : getFixed(outputData.portfolio_index[hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.portfolio_index[hd.title]}}</span>
                  </td>
                </tr>
                <tr v-if="outputData.composite_index">
                  <td>{{'Composite Index'}}</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'Composite'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.composite_index[hd.title] * 100) : getFixed(outputData.composite_index[hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.composite_index[hd.title]}}</span>
                  </td>
                </tr>
                <tr v-if="outputData.sensex_index">
                  <td>{{outputData.sensex_index[1].ind_type}}</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'large'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.sensex_index[1][hd.title] * 100) : getFixed(outputData.sensex_index[1][hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.sensex_index[1][hd.title]}}</span>
                  </td>
                </tr>
                <tr v-if="outputData.sensex_index">
                  <td>{{outputData.sensex_index[0].ind_type}}</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'bsesen'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.sensex_index[0][hd.title] * 100) : getFixed(outputData.sensex_index[0][hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.sensex_index[0][hd.title]}}</span>
                  </td>
                </tr>
                <tr v-if="outputData.sensex_index">
                  <td>{{outputData.sensex_index[2].ind_type}}</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'mid'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.sensex_index[2][hd.title] * 100) : getFixed(outputData.sensex_index[2][hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.sensex_index[2][hd.title]}}</span>
                  </td>
                </tr>
                <tr v-if="outputData.sensex_index">
                  <td>{{outputData.sensex_index[3].ind_type}}</td>
                  <td
                    v-for="(hd, index) in compositeIndex"
                    :key="'sm'+index"
                    :class="{'text-right': hd.type==='numeric'}"
                  >
                    <span
                      v-if="hd.type==='numeric'"
                    >{{(hd.unit==='(%)')? getFixed(outputData.sensex_index[3][hd.title] * 100) : getFixed(outputData.sensex_index[3][hd.title])}}</span>
                    <span v-if="hd.type==='string'">{{outputData.sensex_index[3][hd.title]}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import AddStock from "./add-stock.vue";
export default {
  mixins: [commonMixins],
  name: "PortfolioDetails",
  components: { AddStock },
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "portfolios" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.portId = this.$route.params.id;
    this.pname = this.$route.params.name;
    // this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.portId);
    this.getPortfolioOutput();
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
    }
  },
  data() {
    return {
      isAdd: false,
      pname: "",
      apiUrl: "getPortfolioStockDetails",
      apiMode: true,
      company: {},
      actions: [
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editPortfolio,
          tooltip: "Edit portfolio"
        }
        // {
        //   btnClass: "btn-success",
        //   icon: "fa-eye cwhite",
        //   callback: this.viewPortfolio,
        //   tooltip: "View portfolio"
        // }
      ],
      tableFields: [
        {
          name: "companyname",
          title: "Company"
        },
        {
          name: "date_of_purchase",
          title: "Purchase Date"
        },
        {
          name: "no_of_share_purchased",
          title: "No of shares Purchased"
        },
        {
          name: "price_per_share",
          title: "Purchase Price"
        },
        {
          name: "date_of_sale",
          title: "Sell Date"
        },
        {
          name: "no_of_share_sold",
          title: "No of shares Sold"
        },
        {
          name: "price_at_which_sold",
          title: "Sell Price"
        }
        // {
        //   name: "status",
        //   title: "Status"
        // }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      stockTableFields: [
        { title: "companyname", name: "Stock", type: "string", unit: "" },
        { title: "sectorname", name: "Sector", type: "string", unit: "" },
        { title: "market_cap", name: "Market Cap", type: "number", unit: "" },
        {
          title: "no_of_share_held",
          name: "No of stock held",
          type: "string",
          unit: ""
        },
        {
          title: "latest_price",
          name: "Latest Price",
          type: "number",
          unit: ""
        },
        {
          title: "latest_value",
          name: "Latest Value",
          type: "number",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: "(%)"
        }
      ],
      sectorTableFields: [
        { title: "sectorname", name: "Sector", type: "string", unit: "" },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: "(%)"
        }
      ],
      mcapTableFields: [
        {
          title: "ind_type",
          name: "Market Cap Type",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: "(%)"
        }
      ],
      outputData: [],
      compositeIndex: [
        // {title: 'ind_type', name: , type: 'numeric', unit: ''},
        { title: "one_day", name: "1 Day", type: "numeric", unit: "(%)" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "(%)" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "(%)" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "(%)" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "(%)" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "(%)" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "(%)" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "(%)" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "(%)" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: "(%)"
        }
      ]
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-activity" });
      this.searchParams = {};
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data
          ? { _id: "", portfolio_id: this.portId }
          : { _id: "", portfolio_id: this.portId };
        http.post(this.url, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") { frontend/portfolioOutput
          myself.fillableData = response;
          // myself.current_page = myself.pageToLoad;
          // myself.totalPages = response.total_pages;
          // myself.prevDisabled = myself.pageToLoad == 1;
          // myself.nextDisabled = myself.current_page == myself.totalPages;
          // myself.isLoading = false;
          // // set 5 pages to show
          // console.log("current", myself.current_page);
          // let i = 5;
          // let page = myself.current_page - 2;
          // if (page <= 0) page = 1;
          // myself.pages = [];
          // while (i) {
          //   myself.pages.push(parseInt(page));
          //   if (myself.totalPages <= page) break;
          //   page++;
          //   i--;
          // }
          // console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editPortfolio(row, index, $event) {
      console.log(row, index, $event);
      this.$router.push({
        name: "edit-stock",
        params: { id: row._id, sid: row.portfolio_id, name: this.pname }
      });
    },
    addNew() {
      this.fetchData(this.portId);
      this.getPortfolioOutput();
      this.isAdd = !this.isAdd;
    },
    submitForm(obj) {
      console.log("obj", obj);
      this.addNew();
    },
    getPortfolioOutput() {
      let params = { portfolio_id: this.portId };
      let _this = this;
      http.post("frontend/portfolioOutput", params, function(error, response) {
        console.log(response);
        _this.outputData = response;
        _this.pname = _this.outputData.basic_info.portfolio_name;
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/portfolios/portfolio-details.vue